import { AppError } from '@/errors';

// Re-export AppError for convenience within feature
export { AppError };

interface AppErrorOptions {
  code?: number | null;
  domainCode?: string | null;
  domainMessage?: string | null;
}

export class XmlConversionError extends AppError {
  constructor(message, opts: AppErrorOptions = {}) {
    super(message, opts);
    this.name = 'XmlConversionError';
  }
}

export class XmlConversionNetworkError extends AppError {
  constructor(message, opts: AppErrorOptions = {}) {
    super(message, opts);
    this.name = 'XmlConversionNetworkError';
  }
}

export class XmlConversionBadInputError extends AppError {
  constructor(message, opts: AppErrorOptions = {}) {
    super(message, opts);
    this.name = 'XmlConversionBadInputError';
  }
}

export class DepositSubmissionError extends AppError {
  constructor(message, opts: AppErrorOptions = {}) {
    super(message, opts);
    this.name = 'DepositSubmissionError';
  }
}

export class DepositSubmissionNetworkError extends AppError {
  constructor(message, opts: AppErrorOptions = {}) {
    super(message, opts);
    this.name = 'DepositSubmissionNetworkError';
  }
}

export class DepositSubmissionAuthenticationError extends AppError {
  constructor(message, opts: AppErrorOptions = {}) {
    super(message, opts);
    this.name = 'DepositSubmissionAuthenticationError';
  }
}

export class DepositHistoryNetworkError extends AppError {
  constructor(message, opts: AppErrorOptions = {}) {
    super(message, opts);
    this.name = 'DepositHistoryNetworkError';
  }
}

export interface DoiSearchErrorOptions extends AppErrorOptions {
  retryable?: boolean;
  translationKey?: string;
  doi?: string;
}

export class DoiSearchError extends AppError {
  retryable: boolean;
  translationKey?: string;
  doi?: string;

  constructor(message: string, opts: DoiSearchErrorOptions = {}) {
    super(message, opts);
    this.name = 'DoiSearchError';
    this.retryable = opts.retryable ?? false;
    this.translationKey = opts.translationKey;
    this.doi = opts.doi;
  }
}

